import FilterButtons from "@/components/FilterButtons";
import type { ThemeTag, TopicTag } from "@/lib/constants";
import { theme } from "@/lib/theme";

interface SidebarProps {
  isOpen: boolean;
  selectedThemes: ThemeTag[];
  selectedTopics: TopicTag[];
  onThemeChange: (theme: ThemeTag) => void;
  onTopicChange: (topic: TopicTag) => void;
  onClose?: () => void;
  themeTags: string[];
  topicTags: string[];
}

export default function Sidebar({
  isOpen,
  selectedThemes,
  selectedTopics,
  onThemeChange,
  onTopicChange,
  onClose,
  themeTags,
  topicTags,
}: SidebarProps) {
  return (
    <>
      {isOpen && <div className="md:hidden fixed inset-0 bg-black bg-opacity-50 z-[70]" onClick={onClose} />}

      <div
        className={`fixed inset-y-0 left-0 w-[300px] ${theme.colors.cardCream} dark:bg-gray-800 border-r-2 border-gray-900 dark:border-gray-700 transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } z-[80] md:z-50 md:pt-[88px]`}
      >
        <div className="md:hidden flex justify-end p-4 border-b-2 border-gray-900 dark:border-gray-700">
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-lg transition-colors"
            aria-label="Close sidebar"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="p-6 overflow-y-auto h-[calc(100%-64px)] md:h-full">
          <FilterButtons
            selectedFormat={null}
            selectedThemes={selectedThemes}
            selectedTopics={selectedTopics}
            onFormatChange={() => {}}
            onThemeChange={onThemeChange}
            onTopicChange={onTopicChange}
            themeTags={themeTags}
            topicTags={topicTags}
            showOnlyFormat={false}
          />
        </div>
      </div>
    </>
  );
}
